import { withLayout } from 'layouts';
import ManualEnrolmentComplete from './manual-enrolment-complete.component';

export default withLayout(ManualEnrolmentComplete);
